import React, { useEffect } from 'react';
import { Form, Input, Button, message, notification, Select } from 'antd';
import { useCreateUserAdminPMutation, useUpdateUserAdminPMutation } from '../../../slices/adminApiSlice';

const UserForm = ({ user, getUsers, onClose }) => {
  const [form] = Form.useForm();
  const [api, contextHolder] = notification.useNotification();

  const [createUser, { isLoading: isNewLoading }] = useCreateUserAdminPMutation();
  const [updateUser, { isLoading: isUpdateLoading }] = useUpdateUserAdminPMutation();


  // useEffect(() => {
  //   form.resetFields();
  //   if (user) {
  //     form.setFieldsValue(user);
  //   }
  // }, [user, form]);
useEffect(() => {
  form.resetFields();
  if (user) {
    form.setFieldsValue({
      ...user,
      commission_rate: user.commission_rate || 0, // pre-fill for Partner
    });
  }
}, [user, form]);
  const createuser = async (newUser) => {
    try {
      const res = await createUser(newUser).unwrap();
      message.success('User added successfully');
      getUsers();
    } catch (err) {
      console.log(err);
      api.error({
        message: err?.data?.message || err.error || err?.data?.error || err?.data?.error
      });
    }
  }

  const updateuser = async (updatedUser) => {
    try {
      const res = await updateUser(updatedUser).unwrap();
      message.success('User updated successfully');
      getUsers();
    } catch (err) {
      console.log(err);
      api.error({
        message: err?.data?.message || err.error || err?.data?.error || err?.data?.error
      });
    }
  }

  // const addUserMutation = useMutation(async (newUser) => {
  //   await axios.post('/api/users', newUser);
  //   message.success('User added successfully');
  //   refetch();
  //   onClose();
  // });

  // const updateUserMutation = useMutation(async (updatedUser) => {
  //   await axios.put(`/api/users/${user._id}`, updatedUser);
  //   message.success('User updated successfully');
  //   refetch();
  //   onClose();
  // });

  // const handleSubmit = (values) => {
  //   if (user) {
  //     updateuser(values);
  //   } else {
  //     createuser(values);
  //   }
  // };
const handleSubmit = (values) => {
  const payload = {
    ...values,
    commission_rate:
      values.role === 'Partner' ? Number(values.commission_rate) : 0, // convert to number
  };

  if (user) {
    updateuser(payload);
  } else {
    createuser(payload);
  }
};
  return (
    <>
    {contextHolder}
    <Form form={form} layout="vertical" onFinish={handleSubmit}>
      <Form.Item name="id" hidden>
        <Input />
      </Form.Item>
      <Form.Item name="firstname" label="First Name" rules={[{ required: true }]}>
        <Input />
      </Form.Item>
      <Form.Item name="lastname" label="Last Name" rules={[{ required: true }]}>
        <Input />
      </Form.Item>
      <Form.Item name="email" label="Email" rules={[{ required: true, type: 'email' }]}>
        <Input />
      </Form.Item>
      <Form.Item name="role" label="Role" rules={[{ required: true}]}>
        <Select 
          options={[
            {
              value: 'Admin',
              label: 'Admin',
            },
            {
              value: 'User',
              label: 'User',
            },
                  { value: 'Partner', label: 'Partner' },  // ✅ Added

          ]}
        />
      </Form.Item>
      <Form.Item shouldUpdate={(prevValues, currentValues) => prevValues.role !== currentValues.role}>
  {({ getFieldValue }) =>
    getFieldValue('role') === 'Partner' ? (
      <Form.Item
        name="commission_rate"
        label="Commission Rate (%)"
        rules={[{ required: true, message: 'Please enter commission rate' }]}
      >
        <Input type="number" min={0} max={100} placeholder="Enter commission %" />
      </Form.Item>
    ) : null
  }
</Form.Item>
      <Form.Item name="password" label="Password" rules={[{ required: !user }]}>
        <Input.Password />
      </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit" loading={user ? isUpdateLoading : isNewLoading}>
          {user ? 'Update' : 'Add'} User
        </Button>
      </Form.Item>
    </Form>
    </>
  );
};

export default UserForm;
